import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainerColumnTotal";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./index.css"
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchAttendanceLeaveType, fetchBreakInReportRequest, fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchExtraHoursReport, fetchForm34ReportRequest, fetchLeaveBalanceReportRequest, fetchLeaveReportRequest, getMobilePunchReport, resetAttendanceReport } from "store/actions";
import Loader from "common/pageLoader";

const employeeOptions = [
  { label: "ARUN", value: "ARUN" },
  { label: "GOWRI", value: "GOWRI" },
  { label: "VARMAN", value: "VARMAN" },
  // Add more employee options as needed
];

const data = [
  {
    sno: 1, ltyear: "", jan: 0, feb: 0, mar: 0, apr: 0, may: 0, jun: 0,
    jul: 0, aug: 0, sep: 0, oct: 0, nov: 0, dec: 0, total: 0
  },
  // Add more rows if needed
];



const AttendanceReportBreakInService = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    dropdownAutoList,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.AttendanceReportReducer?.employeeReport ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],

    loading: state.AttendanceReportReducer?.loading,
    error: state.AttendanceReportReducer?.error,
    success: state.AttendanceReportReducer?.success,
  }));

  useEffect(() => {
    dispatch(resetAttendanceReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchEmployeeDropdownAutoList(unitId))
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      employee: "",
    },
    validationSchema: Yup.object({
      employee: Yup.string()
        .nullable()     
        .required("Employee is required")  
    }),
    onSubmit: (values) => {
      // console.log("Form Values:", values);
       const formData = new FormData();
        formData.append("emp_id", values.employee || 0);
        // formData.append("create_by", authDetails?.user_id);
        formData.append("unit_id", authDetails?.unit_id);
  
        dispatch(fetchBreakInReportRequest(formData));
    },
  });


  const employeeReportData = employeeReport?.emp_servicelist ?? [];
  const card_header = employeeReport?.emp_details?.[0] ?? {};


  // Generate columns dynamically from first row keys
 const dynamicColumns = React.useMemo(() => {
    if (!employeeReportData.length) return [];

    const sample = employeeReportData[0];

    // --- FIXED COLUMNS ---
    const fixedColumns = [
      {
        Header: "S.No",
        Cell: ({ row }) => employeeReportData.length - row.index,
        className: "serial-no text-center",
      },
      {
        Header: "LTYear",
        accessor: "year", // your response key
      },
    ];

    // --- DYNAMIC COLUMNS (Months + Total) ---
    const dynamicCols = Object.keys(sample)
      .filter((key) => key !== "s_no" && key !== "year") // skip fixed columns
      .map((key) => ({
        Header: key.charAt(0).toUpperCase() + key.slice(1),
        accessor: key,
        sum: true,
      }));

    return [...fixedColumns, ...dynamicCols];
  }, [employeeReportData]);

  // const columns = [
  //   { Header: "S.No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
  //   { Header: "LTYear", accessor: "ltyear" },
  //   { Header: "Jan", accessor: "jan", sum: true },
  //   { Header: "Feb", accessor: "feb", sum: true },
  //   { Header: "Mar", accessor: "mar", sum: true },
  //   { Header: "Apr", accessor: "apr", sum: true },
  //   { Header: "May", accessor: "may", sum: true },
  //   { Header: "Jun", accessor: "jun", sum: true },
  //   { Header: "Jul", accessor: "jul", sum: true },
  //   { Header: "Aug", accessor: "aug", sum: true },
  //   { Header: "Sep", accessor: "sep", sum: true },
  //   { Header: "Oct", accessor: "oct", sum: true },
  //   { Header: "Nov", accessor: "nov", sum: true },
  //   { Header: "Dec", accessor: "dec", sum: true },
  //   { Header: "Total", accessor: "total", sum: true },
  // ];

  console.log('employeereport > ',employeeReport)

  const handleReset = () => {
      formik.resetForm(); 
      dispatch(resetAttendanceReport()); 
  };

  // const card_header = {
  //     "emp_code": "1728",
  //     "emp_name": "DINESH BABU R",
  //     "date_of_joining": "10/02/2022",
  //     "date_of_retire": null,
  //     "epf_no": ""
  //   };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Break in service" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={4}>
                  <Label>
                    Employee <span className="text-danger">*</span>
                  </Label>
                  <CustomSelect
                      id="employee"
                      name="employee"
                      options={dropdownAutoList.map(emp => ({
                        value: String(emp.emp_id),
                        label: emp.emp_no
                      }))}

                      // UI needs the object, so find matching option
                      value={
                        dropdownAutoList
                          .map(emp => ({
                            value: String(emp.emp_id),
                            label: emp.emp_no
                          }))
                          .find(option => option.value === formik.values.employee) || null
                      }

                      // Form Data: store string only
                      onChange={(selected) =>
                        formik.setFieldValue("employee", selected ? selected.value : "")
                      }
                    />
                    {formik.touched.employee && formik.errors.employee && (
                      <div className="text-danger">
                        {formik.errors.employee}
                      </div>
                    )}
                </Col>
                <Col className="d-flex mob-center align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2 ">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2" onClick={handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {/* {employeeReport && employeeReport.length > 0 && ( */}
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReportData, authDetails?.unit_fullname, authDetails?.unit_address, "BreakInService Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReportData, authDetails?.unit_fullname, authDetails?.unit_address, "BreakInService Report", dynamicColumns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  {/* )}   */}
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

      
        <Card className="shadow custom-elite-card">
          <div className="section-title px-3 py-2">
            <strong>BREAK - IN - SERVICE PARTICULARS</strong>
          </div>
        {Array.isArray(employeeReport) && employeeReport.length === 0 ? (
          <div className="text-center text-muted py-4">
            <i className="fas fa-info-circle fa-2x mb-2" />
            <p className="mb-0">No Records Found</p>
          </div>
        ) : (
          <CardBody>
           <div className="info-grid mb-3">

              <div className="info-item">
                <label>Name</label>
                <span>{card_header?.emp_name || "-----"}</span>
              </div>

              <div className="info-item">
                <label>Account No</label>
                <span>{card_header?.epfo_no || "-----"}</span>
              </div>

              <div className="info-item">
                <label>Date of Joining</label>
                <span>{card_header?.date_of_joining || "-----"}</span>
              </div>

              <div className="info-item">
                <label>Date of Leaving</label>
                <span>{card_header?.date_of_retire || "-----"}</span>
              </div>

            </div>
            <TableContainer
              columns={dynamicColumns}
              data={employeeReportData}
              isGlobalFilter={false}
              customPageSize={10}
              tableSorter={false}
              showTotalRow={true} // If your TableContainer supports this
            />
          </CardBody>
          )}
        </Card>      
      </Container>
    </div>
  );
};

export default AttendanceReportBreakInService;
